import { AfterViewInit, Component, ElementRef, input, OnInit, output, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { CommonButtonRowWidget, CommonTextFieldWidget } from '@eforall/common';
import { Venue } from '@interfaces';
import { VenueEditFormService, VenueEditFormValue } from './venue-edit-form.service';


@Component({
	selector: 'venue-edit-part',
	standalone: true,
	imports: [
		CommonTextFieldWidget,
		CommonButtonRowWidget,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './venue-edit.part.html'
})

export class VenueEditPart implements OnInit, AfterViewInit {

	public form = new VenueEditFormService();

	public venue = input.required<Venue>();
	public venueChanged = output<Venue>();
	public venueFormSaveBtn = viewChild.required<ElementRef<HTMLButtonElement>>('venueFormSaveBtn');


	ngOnInit() {
		this.form.setValues(this.venue());
	}

	ngAfterViewInit() {
		this.form.form.setSubmitButton(
			this.venueFormSaveBtn(),
			async (values: VenueEditFormValue, changed: string[]) => {
				const venue = this.venue();
				if (venue) {
					await this.form.venueDialogDataService.updateVenue({
						venueId: venue.venueId,
						displayedName: values.displayedName, publicNotes: values.publicNotes, internalNotes: values.internalNotes,
					});

					this.venueChanged.emit({
						...venue,
						displayedName: values.displayedName,
						publicNotes: values.publicNotes,
						internalNotes: values.internalNotes,
					});

				}
			}
		);
	}

}